import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from "reactstrap";
import { startOfMonth, format  } from 'date-fns';
import { showToast } from "components/Common";
import StatisticService from "services/Statistic";
import TableDetail from "./TableDetail";
import FilterDetail from "./FilterDetail";
import { DELAY_FETCH } from "constant";
import { scrollToTopRow } from "components/Common/Table";
const Index = ({ isOpen, onClose, data, param }) => {
  const timerRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    statMonthFrom: new Date("0001-01-01"),
    statMonthTo: new Date("0001-01-01"),
  });
  const [paging, setPaging] = useState({
    currentPage: 1,
    pageSize: 100,
  });
  const getRequestParams = (params = {}, requestBody = {}) => {
    const reqParams = {
      params: {
        siteCode: param.value,
        page: paging.currentPage,
        size: paging.pageSize,
        ...params,
      },
      requestBody: { 
        statMonthFrom: format(startOfMonth(filter.statMonthFrom), "yyyy-MM-dd"),
        statMonthTo: format(startOfMonth(filter.statMonthTo), "yyyy-MM-dd"),
        ...requestBody,
      },
    };
    return reqParams;
  };
  const getTableData = (_params = {}, _requestBody = {}) => {
    const { params, requestBody } = getRequestParams(_params, _requestBody);
    setTableData(null);
    setLoading(true);

    timerRef.current = setTimeout(async () => {
      const res =
        await StatisticService.GetListDetailCombineStatMonthlyPatientService(
          params,
          requestBody
        );

      if (res.error) {
        showToast(`${res.error.title}: ${res.error.description}`, 3);
        setTableData([]);
        setLoading(false);
        return;
      }
      setTableData(res);
      setLoading(false);
      scrollToTopRow();
    }, DELAY_FETCH);
  };
  useEffect(() => {
    if (!tableData || !data) return;
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, [tableData || data]);


  useEffect(() => {
    getTableData();
  }, [paging]);
  
  return (
    <Modal
      isOpen={isOpen}
      style={{
        width: "80%",
        maxWidth: "1600px",
        height: "100%",
        //maxHeight: "1200px",
      }}
      toggle={onClose}
    >
      <ModalHeader toggle={onClose}>
        Thống kê số lượng bệnh nhân bệnh viện {param.value} - {param.label}
      </ModalHeader>
      <ModalBody>
        <FilterDetail
          filter={filter}
          setFilter={setFilter}
          isLoading={loading}
          setPaging={setPaging}
          onSearch={() => {
            setPaging(prev => ({ ...prev, currentPage: 1 }));
            getTableData({ page: 1 });
          }}
        />
        <TableDetail
          paging={paging}
          pageSize={paging.pageSize}
          setPaging={setPaging}
          data={tableData}
        />
        <div className="d-flex w-80 justify-content-end">
          <Button color="danger" onClick={onClose}>
            Đóng
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Index;
